import * as types from './types'
import { loadEmployeeSkills as loadEmployeeSkillsRequest } from '@cbgms/api/modules/employee-skills/requests'
import { IEmployeeUser, IPaginatedRequest, IResponse, ISupportEmployee, POSTEmployeeBody, PUTEmployeeBody } from '@cbgms/api'
import {
  createNewEmployee,
  deleteEmployeeUser,
  disableEmployeeAccount,
  enableEmployeeAccount,
  inviteNewEmployee,
  loadEmployeesList,
  loadExistingEmployeeStatus,
  loadSingleEmployee,
  passwordReset,
  setTemporaryPassword,
  updateExistingEmployee
} from '@cbgms/api/modules/employees/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadListShopEmployees = (params: IPaginatedRequest) => ({
  type: [types.LOAD_LIST_EMPLOYEES, types.LOAD_LIST_EMPLOYEES_SUCCESS, types.LOAD_LIST_EMPLOYEES_FAILED],
  payload: {
    api: 'support',
    request: loadEmployeesList(params)
  }
})

export const inviteShopEmployee = (uuid: string, data: any) => ({
  type: [types.INVITE_EMPLOYEE, types.INVITE_EMPLOYEE_SUCCESS, types.INVITE_EMPLOYEE_FAILED],
  payload: {
    api: 'support',
    request: inviteNewEmployee(uuid, data)
  }
})

export const loadEmployeeSkills = (companyUUID: string) => ({
  type: [types.LOAD_EMPLOYEE_SKILLS, types.LOAD_EMPLOYEE_SKILLS_SUCCESS, types.LOAD_EMPLOYEE_SKILLS_FAILED],
  payload: {
    api: 'support',
    request: loadEmployeeSkillsRequest({
      fields: '*',
      search: `EmployeeSkill.CompanyUUID|=|${companyUUID}`
    })
  }
})

export const createEmployee = (data: POSTEmployeeBody<'support'>) => ({
  type: [types.CREATE_EMPLOYEE, types.CREATE_EMPLOYEE_SUCCESS, types.CREATE_EMPLOYEE_FAILED],
  payload: {
    api: 'support',
    request: createNewEmployee(data)
  }
})

export const updateEmployee = (uuid: string, data: PUTEmployeeBody<'support'>) => ({
  type: [types.UPDATE_EMPLOYEE, types.UPDATE_EMPLOYEE_SUCCESS, types.UPDATE_EMPLOYEE_FAILED],
  payload: {
    api: 'support',
    request: updateExistingEmployee(uuid, data)
  }
})

export const loadEmployee = (uuid: string) =>
  AsyncAction<IResponse<ISupportEmployee>>({
    type: [types.LOAD_EMPLOYEE, types.LOAD_EMPLOYEE_SUCCESS, types.LOAD_EMPLOYEE_FAILED],
    payload: {
      api: 'support',
      request: loadSingleEmployee(uuid)
    }
  })

export const loadEmployeeStatus = (uuid: string) =>
  AsyncAction<IResponse<IEmployeeUser>>({
    type: [types.LOAD_EMPLOYEE_STATUS, types.LOAD_EMPLOYEE_STATUS_SUCCESS, types.LOAD_EMPLOYEE_STATUS_FAILED],
    payload: {
      api: 'support',
      request: loadExistingEmployeeStatus(uuid)
    }
  })

export const disableUser = (uuid: string) => ({
  type: [types.DISABLE_EMPLOYEE, types.DISABLE_EMPLOYEE_SUCCESS, types.DISABLE_EMPLOYEE_FAILED],
  payload: {
    api: 'support',
    request: disableEmployeeAccount(uuid)
  }
})

export const triggerPasswordReset = (uuid: string, shopID: string) => ({
  type: [
    types.TRIGGER_EMPLOYEE_PASSWORD_RESET,
    types.TRIGGER_EMPLOYEE_PASSWORD_RESET_SUCCESS,
    types.TRIGGER_EMPLOYEE_PASSWORD_RESET_FAILED
  ],
  payload: {
    api: 'support',
    request: passwordReset(uuid, shopID)
  }
})

export const triggerSetTemporaryPassword = (uuid: string, shopID: string, temporaryPassword: string) => ({
  type: [
    types.TRIGGER_EMPLOYEE_SET_TEMPORARY_PASSWORD,
    types.TRIGGER_EMPLOYEE_SET_TEMPORARY_PASSWORD_SUCCESS,
    types.TRIGGER_EMPLOYEE_SET_TEMPORARY_PASSWORD_FAILED
  ],
  payload: {
    api: 'support',
    request: setTemporaryPassword(uuid, shopID, temporaryPassword)
  }
})

export const enableUser = (uuid: string) => ({
  type: [types.DISABLE_EMPLOYEE, types.DISABLE_EMPLOYEE_SUCCESS, types.DISABLE_EMPLOYEE_FAILED],
  payload: {
    api: 'support',
    request: enableEmployeeAccount(uuid)
  }
})

export const deleteUser = (uuid: string) =>
  AsyncAction<void>({
    type: [types.DELETE_EMPLOYEE_USER, types.DELETE_EMPLOYEE_USER_SUCCESS, types.DELETE_EMPLOYEE_USER_FAILED],
    payload: {
      api: 'support',
      request: deleteEmployeeUser(uuid)
    }
  })
